import { createFileRoute } from "@tanstack/react-router";
import { TermsOfServicePage } from "@/app/marketing/TermsOfServicePage";

export const Route = createFileRoute("/terms")({
  component: TermsOfServicePage,
});
